import { render, staticRenderFns } from "./addCanteen.vue?vue&type=template&id=de93201a&scoped=true&"
import script from "./addCanteen.vue?vue&type=script&lang=js&"
export * from "./addCanteen.vue?vue&type=script&lang=js&"
import style0 from "./addCanteen.vue?vue&type=style&index=0&id=de93201a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de93201a",
  null
  
)

export default component.exports